import { render } from "./FooterHomePage.vue?vue&type=template&id=c348af42"
import script from "./FooterHomePage.vue?vue&type=script&lang=js"
export * from "./FooterHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__